import { toast } from "react-toastify";
import store from "../../../../../store";

export const minimapStyle = {
    height: 100,
    width: 140,
};

export const nodeColor = (node) => {
    switch (node.type) {
        case "rootNode":
            return "#6AC96E";
        case "addNode":
            return "#17c2e0";
        case "conditionalNode":
            return "#1c1c1f";
        default:
            return "#868df4";
    }
};

export const nodeActionsLists = [
    { id: 1, label: "Condition Box", value: "condition_action" },
    { id: 2, label: "Bulk Action Box", value: "bulk_action" },
];
// export const ruleActionLists = [
//     { id: 1, label: "Set Tag", value: "ticket_tag" },
//     { id: 2, label: "Change Ticket Status", value: "ticket_status" },
//     { id: 3, label: "Send Auto Response", value: "auto_response" },
//     { id: 4, label: "Set Sentiment", value: "sentiment" },
//     // { id: 4, label: "mention", value: "Volume of Conversation" },
//     // { id: 5, label: "impact_value", value: "Impact Value" },
// ];

export const sentimentTypes = [
    {
        id: 1,
        label: "Positive",
        value: "POSITIVE",
    },
    {
        id: 2,
        label: "Negative",
        value: "NEGATIVE",
    },
    {
        id: 3,
        label: "Neutral",
        value: "NEUTRAL",
    },
];
export const tagsOption = () => {
    const tagsObject = store.getState().socialResponseReducer.smrTags || {};
    const options = Object.keys(tagsObject).map((val, id) => ({ id, label: val, value: val }));

    // sort by label property
    options.sort((a, b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
        if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
        return 0;
    });

    return options;
};

export const postTypeOption = () => {
    return [
        { id: 1, label: "Private Message", value: "DM" },
        { id: 2, label: "Public Comment", value: "COMMENT" },
    ];
};

export const agentOptions = () => {
    const agentObject = store.getState().socialResponseReducer.agentListValue || {};
    const options = Object.values(agentObject)
        ?.filter((agent) => ["cxa", "cxm"].some((role) => agent.roles?.includes(role)))
        .map((agent, id) => ({ id, label: agent.name, value: agent.lite_id }));
    return options;
};

export const cannedResponseOptions = () => {
    const cannedRespList = store.getState().cannedResponseReducer.cannedResponseList || [];
    const options = cannedRespList.map((resp, id) => ({ id, label: resp.title, value: resp.id }));
    return options;
};
export const ticketStatusOptions = () => {
    const ticketStatus = store.getState().socialResponseReducer.statusList || {};
    const ticketOption = ticketStatus.statuses?.map((obj) => ({ id: obj.id, label: obj.status, value: obj.status }));
    return ticketOption;
};
export const pageOptions = () => {
    const smrPages = store.getState().socialResponseReducer.smrPagesList || {};

    const smrPageArr = Object.values(smrPages);
    const sortedSmrPageArr = smrPageArr.sort((a, b) => a.platform.localeCompare(b.platform));
    const groupedSmrPageArr = sortedSmrPageArr.reduce((acc, cur) => {
        acc[cur.platform] = acc[cur.platform] || [];
        acc[cur.platform].push(cur);
        return acc;
    }, {});

    const sortArrayByStatus = (array) => {
        return array.sort((a, b) => {
            if (a.status === "Active" && b.status !== "Active") {
                return -1;
            }
            if (b.status === "Active" && a.status !== "Active") {
                return 1;
            }
            return 0;
        });
    };

    // console.log('smrPagesObj', smrPages);
    // console.log('smrPagesObjValues', Object.values(smrPages));
    // console.log("groupedArray", groupedArray);
    // console.log('objectValuesGroupedArray', Object.values(groupedArray));

    // const options = Object.values(smrPages)
    //     // ?.filter((obj) => obj.status === "Active")
    //     //?.sort((a, b) => (a.page_name.toLowerCase() < b.page_name.toLowerCase() ? -1 : a.page_name.toLowerCase() > b.page_name.toLowerCase() ? 1 : 0))
    //     ?.map((page, id) => {
    //         //console.log("aaa", page.status);
    //         let inActive = page.status !== "Active";
    //         // console.log('inActive', inActive);
    //         return {
    //             id,
    //             label:
    //                 page.platform === "instagram"
    //                     ? `${page.page_username}${inActive ? " (Inactive)" : ""}`
    //                     : `${page.page_name}${inActive ? " (Inactive)" : ""}`,
    //             value: page.page_id,
    //             imageURL: page.page_profile_pic,
    //             platform: page.platform,
    //         };
    //     });

    // --------------- SORTED OPTIONS --------------------------------------------
    const sortedOptions = [];
    let id = 0;
    Object.values(groupedSmrPageArr).forEach((platform) => {
        sortArrayByStatus(platform);
        platform.map((page) => {
            let inActive = page.status !== "Active";
            sortedOptions.push({
                id: id++,
                label:
                    page.platform === "instagram"
                        ? `${page.page_username}${inActive ? " (Inactive)" : ""}`
                        : `${page.page_name}${inActive ? " (Inactive)" : ""}`,
                value: page.page_id,
                imageURL: page.page_profile_pic,
                platform: page.platform,
            });
        });
    });
    // --------------- SORTED OPTIONS --------------------------------------------

    // cannedRespList.map((resp, id) => ({ id, label: resp.title, value: resp.id }));
    // console.log('options', options);
    return sortedOptions;
};

export const keywordOption = () => {
    const keywordLists = store.getState().socialResponseReducer.smrKeywords || [];
    const options = keywordLists.map((val, id) => ({ id, label: val.name, value: val.id }));

    // sort by label property
    options.sort((a, b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
        if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
        return 0;
    });

    return options;
};
export const platformOptions = () => {
    return [
        {
            id: 7,
            label: "App Store",
            value: "appstore",
        },
        {
            id: 1,
            label: "Facebook",
            value: "facebook",
        },
        {
            id: 5,
            label: "Google Business",
            value: "gmb",
        },
        {
            id: 2,
            label: "Instagram",
            value: "instagram",
        },
        {
            id: 4,
            label: "LinkedIn",
            value: "linkedin",
        },
        {
            id: 6,
            label: "Play Store",
            value: "playstore",
        },
        {
            id: 8,
            label: "Telegram",
            value: "telegram",
        },
        {
            id: 3,
            label: "X",
            value: "twitter",
        },
        {
            id: 9,
            label: "YouTube",
            value: "youtube",
        },
    ];
};
export const langaugeOptions = () => {
    const languages = store.getState().filterSettingReducer.masterLanguages;
    const options = languages
        ?.sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : a.name.toLowerCase() > b.name.toLowerCase() ? 1 : 0))
        ?.map((lang) => ({ id: lang.id, label: lang.name, value: lang.short_name }));
    return options;
};

export const priorityOptions = () => {
    return [
        {
            id: 1,
            label: "High",
            value: "HIGH",
        },
        {
            id: 2,
            label: "Medium",
            value: "MEDIUM",
        },
        {
            id: 3,
            label: "Low",
            value: "LOW",
        },
    ];
};

// export const ruleEngineModalContents = (action) => {
//     const obj = {
//         options: [],
//         description: "",
//         placeholder: "",
//     };

//     switch (action.value) {
//         case "ticket_tag":
//             obj.options = sentimentTypes;
//             obj.description = "Set Tag";
//             obj.placeholder = "Set Tag";
//             break;

//         case "ticket_status":
//             obj.options = sentimentTypes;
//             obj.description = "Change Ticket Status";
//             obj.placeholder = "Change Ticket Status";
//             break;

//         default:
//             break;
//     }
//     return obj;
// };

export const actionOptions = [
    { id: 1, label: "Tag", value: "ticket_tag", fieldsEnabled: ["condition"] },
    { id: 2, label: "Ticket Status", value: "ticket_status", fieldsEnabled: ["action"] },
    { id: 3, label: "Ticket Priority", value: "ticket_priority", fieldsEnabled: ["action"] },
    // { id: 3, label: "Assignee", value: "assignee", fieldsEnabled: ["action", "condition"] },
    { id: 4, label: "Sentiment", value: "sentiment", fieldsEnabled: ["action", "condition"] },
    { id: 5, label: "Close Ticket", value: "close_conversation", fieldsEnabled: ["action"] },
    // { id: 6, label: "Send Canned Response", value: "canned_response", fieldsEnabled: ["action"] },
    { id: 7, label: "Platform", value: "platform", fieldsEnabled: ["condition"] },
    { id: 8, label: "Account", value: "page_ids", fieldsEnabled: ["condition"] },
    { id: 9, label: "Language", value: "language", fieldsEnabled: ["condition"] },
    { id: 10, label: "Send Auto Response", value: "send_auto_response", fieldsEnabled: ["action"] },
    { id: 11, label: "Post Type", value: "post_type", fieldsEnabled: ["condition"] },
];

export const conditionActionOperatorOptions = [
    {
        id: 1,
        label: "Is",
        value: "is",
        fieldsEnabled: ["ticket_tag", "sentiment", "assignee", "page_ids", "platform", "ticket_status", "language", "rule_id", "post_type"],
    },
    {
        id: 2,
        label: "Is Not",
        value: "is_not",
        fieldsEnabled: ["ticket_tag", "sentiment", "assignee", "page_ids", "platform", "ticket_status", "language", "rule_id"],
    },
    // { id: 3, label: "Unset", value: "unset", fieldsEnabled: ["ticket_tag"] },
    // { id: 4, label: "Merge", value: "merge", fieldsEnabled: ["ticket_tag"] },
    // { id: 5, label: "Remove", value: "remove", fieldsEnabled: ["ticket_tag"] },
];

export const bulkActionOperatorOptions = [
    { id: 1, label: "Set", value: "set", fieldsEnabled: ["ticket_tag", "sentiment", "assignee", "ticket_status", "ticket_priority"] },
    // { id: 2, label: "Set If absent", value: "set_if_absent", fieldsEnabled: ["ticket_tag"] },
    // { id: 3, label: "Unset", value: "unset", fieldsEnabled: ["ticket_tag"] },
    // { id: 4, label: "Merge", value: "merge", fieldsEnabled: ["ticket_tag"] },
    // { id: 5, label: "Remove", value: "remove", fieldsEnabled: ["ticket_tag"] },
];

export const getActionEventOptions = (actionFields, isConditionAction) => {
    const actionType = isConditionAction ? "condition" : "action";
    const options = [];
    actionOptions.forEach((actionObj) => {
        if (!actionFields.some((obj) => obj.action?.value === actionObj.value) && actionObj.fieldsEnabled.includes(actionType)) {
            options.push(actionObj);
        }
    });
    return options;
};
export const getActionOptions = (action) => {
    let option = [];

    switch (action) {
        case "ticket_tag":
            option = tagsOption();
            break;

        case "ticket_status":
            option = ticketStatusOptions();
            break;

        case "assignee":
            option = agentOptions();
            break;

        case "sentiment":
            option = sentimentTypes;
            break;

        case "canned_response":
            option = cannedResponseOptions();
            break;
        case "page_ids":
            option = pageOptions();
            break;

        case "platform":
            option = platformOptions();
            break;

        case "language":
            option = langaugeOptions();
            break;

        case "rule_id":
            option = keywordOption();
            break;

        case "ticket_priority":
            option = priorityOptions();
            break;

        case "post_type":
            option = postTypeOption();
            break;

        default:
            break;
    }
    return option;
};

export const getOperatorAndValueOptions = (actionObj, isConditionAction) => {
    const operatorOptions = [];
    const valueOptions = [];
    if (actionObj.value) {
        if (isConditionAction)
            conditionActionOperatorOptions.forEach((obj) => {
                if (obj.fieldsEnabled.includes(actionObj.value)) operatorOptions.push(obj);
            });
        else
            bulkActionOperatorOptions.forEach((obj) => {
                if (obj.fieldsEnabled.includes(actionObj.value)) operatorOptions.push(obj);
            });
        let option = getActionOptions(actionObj.value);

        if (option && option.length > 0) valueOptions.push(...option);
    }
    return {
        operatorOptions,
        valueOptions,
    };
};

export const validateActions = (actions, isConditionAction, boxName) => {
    let isValidActions = true;

    if (boxName.trim().length === 0) {
        toast.error("Box Title is required");
        isValidActions = false;
        return isValidActions;
    }

    actions.forEach((obj) => {
        if (!obj.action?.value) {
            toast.error(`Please select Action field`);
            isValidActions = false;
            return;
        }
        if (!obj.operator?.value && !["close_conversation", "canned_response", "send_auto_response"].includes(obj.action?.value)) {
            toast.error(`Please select Operator field for "${obj.action?.label}"`);
            isValidActions = false;

            return;
        }
        if (isConditionAction) {
            if (obj.value?.length < 1) {
                toast.error(`Please select Value field for "${obj.action?.label}"`);
                isValidActions = false;
                return;
            }
        } else {
            if (["send_auto_response"].includes(obj.action?.value)) {
                if (obj.value?.trim().length < 1) {
                    toast.error(`Please select Value field for "${obj.action?.label}"`);
                    isValidActions = false;
                }

                return;
            } else if (!obj.value?.value && !["close_conversation"].includes(obj.action?.value)) {
                toast.error(`Please select Value field for "${obj.action?.label}"`);
                isValidActions = false;

                return;
            }
        }
    });
    return isValidActions;
};
export const getActionValueType = (isConditionAction = false, action = {}) => {
    //value type supported --> "singleField","multiField","inputField"
    // console.log("action.value", action.value);
    if (action.value === "post_type") return "singleField";
    if (isConditionAction) {
        return "multiField";
    }

    if (action.value === "send_auto_response") return "inputField";
    return "singleField";
};

export const getEmptyValue = (valueType = "") => {
    switch (valueType) {
        case "multiField":
            return [];

        case "singleField":
            return {};

        case "inputField":
            return "";

        default:
            return {};
    }
};

const getPlatformFullName = (platform) => {
    const obj = {
        facebook: "Facebook",
        instagram: "Instagram",
        twitter: "Twitter",
        linkedin: "LinkedIn",
        youtube: "YouTube",
        appstore: "App Store",
        gmb: "Google Business",
        playstore: "Play Store",
    };
    return obj[platform] || platform;
};
